// This controller collects all parameters from the form and reloads the page with those parameters.
//
// Struct example (Pseudo code):
// div[data-controller="reload-page-with-params"]
//   select_tag[data-action: "change->reload-page-with-params#reload"]

import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  reload() {
    const params = new URLSearchParams(new FormData(event.currentTarget.form)).toString();

    window.location = `${window.location.href}?${params}`;
  }
}
